import React from 'react';
import styles from './index.module.scss';
import { Skeleton, UiKit } from 'components';

export default function ExceptionConfigLoader({
  isLoading = false,
  children = null
}) {
  if (!isLoading) return children;

  const input = (
    <div className={styles.inputWrapper}>
      <Skeleton width="100px" className={styles.label} />
      <Skeleton className={styles.input} height="44px" />
    </div>
  );

  const radio = (
    <UiKit.Grid gap="16px" templateColumns="14px 1fr">
      <Skeleton width="14px" height="14px" circle />
      <Skeleton width="100%" height="14px" />
    </UiKit.Grid>
  );

  return (
    <>
      <UiKit.Grid gap="16" className={styles.inputs}>
        {input}
        {input}
      </UiKit.Grid>
      <Skeleton width="160px" className="mb-3" />
      <UiKit.Grid templateColumns="250px 194px" gap="50">
        {radio}
        {radio}
      </UiKit.Grid>
    </>
  );
}
